import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { establish_word_object_for_tokens } from '../../../services/translate/_methods/establish_word_object_for_tokens';

export function FN_WORDS__init_in_tokens_search(entities: DTOSearchSettings[]) {
  for (let entity of entities) {
    entity.tokens = establish_word_object_for_tokens(entity.tokens);

    entity.tokens = entity.tokens.sort(DTO__token.sortByWordTranslated);
  }
}
